import { Card, CardContent } from "@/components/ui/card";
import { Button } from "@/components/ui/button";
import { Plus, Trash2, Mail } from "lucide-react";

export default function FeeMemberCard({ member: m, payments, total, overdue, reminding, onLog, onRemind, onDelete, onResendReceipt }) {
  return (
    <Card className="card-shadow-soft" data-testid={`fee-card-${m.id}`}>
      <CardContent className="p-4 space-y-3">
        <div className="flex items-start justify-between">
          <div>
            <div className="font-semibold">{m.full_name}</div>
            <div className="text-xs text-muted-foreground">€{Number(m.fee_amount).toFixed(2)} / {m.fee_frequency}</div>
            {overdue?.overdue && (
              <span data-testid={`fee-overdue-${m.id}`} className="scout-tag bg-red-100 text-red-700 dark:bg-red-900/40 dark:text-red-300 mt-1.5">
                Overdue · {overdue.overdue_by} period(s)
              </span>
            )}
          </div>
          <div className="flex gap-1.5">
            {overdue?.overdue && m.email && (
              <Button size="sm" variant="outline" disabled={reminding} onClick={() => onRemind(m)} data-testid={`remind-fee-${m.id}`}>
                <Mail className="w-4 h-4 mr-1" /> {reminding ? "Sending…" : "Remind"}
              </Button>
            )}
            <Button size="sm" onClick={() => onLog(m)} data-testid={`log-fee-${m.id}`}>
              <Plus className="w-4 h-4 mr-1" /> Log
            </Button>
          </div>
        </div>
        <div className="text-xs text-muted-foreground">
          Paid so far: <span className="text-foreground font-semibold">€{total.toFixed(2)}</span> · {payments.length} entries
        </div>
        {payments.length > 0 && (
          <div className="space-y-1 max-h-32 overflow-y-auto">
            {payments.slice(0, 5).map((p) => (
              <div key={p.id} className="flex items-center justify-between text-xs border-t border-border pt-1" data-testid={`fee-row-${p.id}`}>
                <span>{p.period} · {p.paid_on}{p.receipt_sent_at && <span title={`Receipt ${p.receipt_no} emailed`} data-testid={`fee-receipt-${p.id}`} className="ml-1 text-green-700">✓ receipt</span>}</span>
                <span className="flex items-center gap-2">
                  <span className="font-semibold">€{Number(p.amount).toFixed(2)}</span>
                  {m.email && (
                    <button onClick={() => onResendReceipt(p.id)} title="Resend receipt to parent" className="text-primary" data-testid={`fee-resend-receipt-${p.id}`}>
                      <Mail className="w-3 h-3" />
                    </button>
                  )}
                  <button onClick={() => onDelete(p.id)} className="text-destructive" data-testid={`fee-del-${p.id}`}>
                    <Trash2 className="w-3 h-3" />
                  </button>
                </span>
              </div>
            ))}
          </div>
        )}
      </CardContent>
    </Card>
  );
}
